import type { Case } from 'types/case'
import { regEx } from 'utils/global/regEx'

export const resolvePath = (path: string, caseDetails: Case) => {
  let resolvedPath = path
  const beginningOfServicePath = 'services['
  const isServicePath = path?.startsWith(beginningOfServicePath)
  const defaultServiceIsSet = caseDetails?.default_service
  const shouldResolveServicePath = isServicePath && defaultServiceIsSet
  if (shouldResolveServicePath) {
    const propertyPath = path.replace(regEx.serviceAtIndex, '')
    if (propertyPath) {
      resolvedPath = `default_service${propertyPath}`
    }
  }
  return resolvedPath
}
